import * as React from "react";
import { OldProgressBarQuestionnaireSectionUnconnected } from "@teamprevent/common/questionnaires/components/OldProgressBarQuestionnaireSection";
import { CheckboxQuestion } from "@teamprevent/common/questionnaires/components/questions/CheckboxQuestion";
import { getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";

import { connect } from "react-redux";

import { mapDispatchToQuestionnaireSectionProps, makeMapStateToQuestionnaireSectionProps } from "@teamprevent/common/questionnaires/mappers";

import { HealthSurveillanceSectionProps } from "../models";
import * as questionIds from "../questions/questionIds";
import { sections } from "../questionnaire";

const HealthSurveillanceDeclarationSectionUnconnected: React.FunctionComponent<HealthSurveillanceSectionProps> = (props: HealthSurveillanceSectionProps) => {
    return (
        <OldProgressBarQuestionnaireSectionUnconnected
            {...props}
            {...sections.DeclarationOfHealth}
        >
            <CheckboxQuestion
                readonly={props.readonly}
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.Declaration1)}
                value="Agree"
                mandatory
            />
            <CheckboxQuestion
                readonly={props.readonly}
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.Declaration2)}
                value="Agree"
                mandatory
            />
        </OldProgressBarQuestionnaireSectionUnconnected>
    );
};

export const HealthSurveillanceDeclarationSection = connect(
    makeMapStateToQuestionnaireSectionProps(sections.DeclarationOfHealth.id),
    mapDispatchToQuestionnaireSectionProps)(HealthSurveillanceDeclarationSectionUnconnected);
